import type { SubscriptionStatus } from '../types/subscriptionStatus';

export type SubscriptionStatusOption = {
  label: string;
  value: SubscriptionStatus;
};

export const SUBSCRIPTION_STATUS_OPTIONS: SubscriptionStatusOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Active + Trial', value: 'active_trial' },
  { label: 'Trial', value: 'trial' },
  { label: 'Active', value: 'active' },
  { label: 'Cancelled', value: 'canceled' },
  { label: 'Pending Activation', value: 'pending_activation' },
  { label: 'Pending Cancel', value: 'pending_cancel' },
];
